module.exports = __webpack_public_path__ + "img/cate-5-d38f4b.png";